import { CreateTenantBillingDto } from './create-tenant-billing.dto';

/**
 * Billing fields on tenant update. Same trial dates as create, plus provider
 * customer ids and metadata.
 */
export class UpdateTenantBillingDto extends CreateTenantBillingDto {
  meteringProviderCustomerId?: string | null;
  billingProviderCustomerId?: string | null;
  meteringProviderMetadata?: Record<string, unknown> | null;
  billingProviderMetadata?: Record<string, unknown> | null;
}
